import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { windowProvider } from '@inshared/shared/util';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AutorisatieMenuModule } from '../autorisatie-menu/autorisatie-menu.module';
import { TopbarComponent } from './topbar.component';
import { TopbarContainer } from './topbar.container';

@NgModule({
    imports: [CommonModule, AutorisatieMenuModule, LazyLoadImageModule, RouterModule],
    declarations: [TopbarComponent, TopbarContainer],
    exports: [TopbarContainer],
    providers: [windowProvider],
})
export class TopbarModule {}
